<template>
  <div>
    <!-- Modal -->
    <div class="modal fade mt-150"
         id="agreeTermsModal"
         tabindex="-1"
         role="dialog"
         aria-labelledby="agreeTermsModalLabel"
         aria-hidden="true"
         >
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header flex align-items-center" >
            <img class="pr-2" width="70px" src="/img/logo.svg" alt="logo"/>
            <h5 class="modal-title " id="agreeTermsModalLabel">Termet dhe Kushtet e perdorimit</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-close"></i>
            </button>
          </div>
          <div class="modal-body">
            <p>Këtu janë shfaqur kushtet e përdorimit të "Marimanga".</p>
            <p>Me rastin e regjistrimit do të pranoni në email linkun i cili përmban kushtet e përdorimit për pakon e blerë.</p>
            <a
                :href="`${frontUrl}/pdf/${this.id}.pdf`"
                target="_blank">Lexo kushtet e përdorimit >
            </a>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark p-1" data-dismiss="modal">Pranoj</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      frontUrl: process.env.VUE_APP_FRONT_END_BASE_URL,
      id: this.$route.params.package,
    }
  }
}

</script>